import React from 'react'
import { useGetPhoneSettings } from 'apps/user/apiTypes/phoneSettings'
import { PermissionCard } from './PermissionCard'
import { PhoneInfoCard } from './PhoneInfoCard'

export const Tracking = ({ parentUserID }: { parentUserID: number }) => {
  const { data, error } = useGetPhoneSettings({ id: parentUserID })
  if (data || error) {
    return (
      <>
        <div className='row'>
          <div className='col-xs-12 col-md-6'>
            <PhoneInfoCard
              cellPhone={data?.cellPhone}
              phoneModel={data?.phoneModel}
              phoneOS={data?.phoneOs}
              transfixAppVersion={data?.settings?.transfixAppVersion}
            />
          </div>
          <div className='col-xs-12 col-md-6'>
            <PermissionCard
              settings={data?.settings ? data?.settings : {}}
              lastPingAt={data?.lastPingAt}
              errorMessage={error?.data ? String(error?.data) : undefined}
            />
          </div>
        </div>
      </>
    )
  }
  return <div />
}
